import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0a0c14] border-t border-white/5 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/6b16baefe27f95e20b53c0649a41ad2b/211b6fcc0069220512ea7afec14e43c5.jpeg"
              alt="GK Vertex Consulting"
              className="h-14 w-auto object-contain mb-5"
            />
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              We build modern, high-performance websites that turn visitors into clients. Premium design. Real results.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-white/50 hover:text-[#d4af37] hover:border-[#d4af37] transition-all duration-200 cursor-pointer">
                <i className="ri-linkedin-fill text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-white/50 hover:text-[#d4af37] hover:border-[#d4af37] transition-all duration-200 cursor-pointer">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-white/10 text-white/50 hover:text-[#d4af37] hover:border-[#d4af37] transition-all duration-200 cursor-pointer">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white text-sm font-semibold tracking-widest uppercase mb-5">Navigate</h4>
            <ul className="space-y-3">
              {[
                { label: "Home", path: "/" },
                { label: "Services", path: "/services" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-white/50 text-sm hover:text-[#d4af37] transition-colors duration-200 cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a href="#contact" className="text-white/50 text-sm hover:text-[#d4af37] transition-colors duration-200 cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white text-sm font-semibold tracking-widest uppercase mb-5">Get In Touch</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-white/50 text-sm">
                <i className="ri-mail-line text-[#d4af37]"></i>
                gkvertexconsulting@gmail.com
              </li>
              <li className="flex items-start gap-2 text-white/50 text-sm">
                <i className="ri-phone-line text-[#d4af37] mt-0.5"></i>
                <span>347-814-4383<br />914-584-5989</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; 2025 GK Vertex Consulting. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/30 text-xs hover:text-[#d4af37] transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-white/30 text-xs hover:text-[#d4af37] transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
